import { useToast } from "primevue";
import type { ProblemDetails } from "shared/problems/domain/problemDetails";

export function useActionFailedAlert() {
  const toast = useToast();

  return {
    show
  };

  function show(details: ProblemDetails) {

    const summaryList: string[] = [];

    summaryList.push(details.title);

    if (details.errors) {
      const items = details.errors;
      for (const [key, value] of Object.entries(items)) {
        summaryList.push(...value);
      }
    }

    toast.add({
      severity: "error",
      detail: summaryList.join('\n'),
      summary: details.detail,
      life: 5000
    })
  }
}
